var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 380,
    viewBox: "0 0 550 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M550 275.501C550 123.346 426.878 0 275 0C123.122 0 0 123.346 0 275.501C0 312.489 7.2986 347.774 20.4937 380H529.496C542.691 347.774 549.99 312.489 549.99 275.501H550Z",
    fill: "url(#paint0_linear_727_88148)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_727_88148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 550,
    height: 380
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M550 275.501C550 123.346 426.878 0 275 0C123.122 0 0 123.346 0 275.501C0 312.489 7.2986 347.774 20.4937 380H529.496C542.691 347.774 549.99 312.489 549.99 275.501H550Z",
    fill: "url(#paint1_linear_727_88148)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M550 275.501C550 123.346 426.878 0 275 0C123.122 0 0 123.346 0 275.501C0 312.489 7.2986 347.774 20.4937 380H529.496C542.691 347.774 549.99 312.489 549.99 275.501H550Z",
    fill: "url(#paint2_radial_727_88148)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M550 275.501C550 123.346 426.878 0 275 0C123.122 0 0 123.346 0 275.501C0 312.489 7.2986 347.774 20.4937 380H529.496C542.691 347.774 549.99 312.489 549.99 275.501H550Z",
    fill: "url(#paint3_radial_727_88148)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M550 275.501C550 123.346 426.878 0 275 0C123.122 0 0 123.346 0 275.501C0 312.489 7.2986 347.774 20.4937 380H529.496C542.691 347.774 549.99 312.489 549.99 275.501H550Z",
    fill: "url(#paint4_radial_727_88148)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M550 275.501C550 123.346 426.878 0 275 0C123.122 0 0 123.346 0 275.501C0 312.489 7.2986 347.774 20.4937 380H529.496C542.691 347.774 549.99 312.489 549.99 275.501H550Z",
    fill: "url(#paint5_radial_727_88148)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_727_88148)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.702,
    cy: 257.973,
    r: 45.6981,
    fill: "#F26C69"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.6 248.895C195.826 242.139 201.269 236.699 208.099 236.699C214.921 236.699 220.599 242.339 220.599 249.144V255.215C223.594 255.964 225.799 258.647 225.799 261.881V272.826C225.799 276.647 222.721 279.699 218.899 279.699H197.099C193.278 279.699 190.199 276.647 190.199 272.826V261.881C190.199 258.576 192.503 255.845 195.599 255.169V248.945C195.599 248.929 195.599 248.912 195.6 248.895ZM198.599 255.008H217.599V249.144C217.599 244.01 213.278 239.699 208.099 239.699C202.938 239.699 198.785 243.799 198.599 248.971V255.008ZM197.099 258.008C194.921 258.008 193.199 259.731 193.199 261.881V272.826C193.199 274.976 194.921 276.699 197.099 276.699H218.899C221.078 276.699 222.799 274.976 222.799 272.826V261.881C222.799 259.731 221.078 258.008 218.899 258.008H197.099ZM206.464 263.411C206.879 263.05 207.466 262.769 208.099 262.769C208.732 262.769 209.32 263.05 209.734 263.411C210.176 263.796 210.599 264.43 210.599 265.264C210.599 265.906 210.378 266.556 209.882 267.049C209.793 267.138 209.698 267.218 209.599 267.289V270.04C209.599 270.868 208.928 271.54 208.099 271.54C207.271 271.54 206.599 270.868 206.599 270.04V267.289C206.5 267.218 206.406 267.138 206.316 267.049C205.821 266.556 205.599 265.906 205.599 265.264C205.599 264.43 206.022 263.796 206.464 263.411Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.236 193.379L322.232 257.57L285.363 249.078L283.281 237.255L315.169 229.845L332.236 193.379Z",
    fill: "url(#paint6_linear_727_88148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.987 382.787L320.148 382.787L315.793 280.444L340.181 280.444L327.987 382.787Z",
    fill: "url(#paint7_linear_727_88148)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.664 293.454H341.513L365.701 382.762L375.376 382.762L363.157 274.156L365.375 276.471L367.892 269.415C372.324 256.989 372.843 243.505 369.38 230.775L361.379 201.374L360.92 202.216C357.725 196.845 351.878 193.381 345.381 193.381H332.239L310.664 288.71V293.454Z",
    fill: "url(#paint8_linear_727_88148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.065 290.648L358.953 290.815L365.37 276.451L362.4 265.208C358.34 266.167 354.807 268.657 352.538 272.158L347.482 279.962L348.565 280.699L354.785 275.886L353.065 290.648Z",
    fill: "#242D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.876 175.288C358.876 182.994 352.63 189.241 344.924 189.241C337.219 189.241 330.973 182.994 330.973 175.288C330.973 167.583 337.219 161.336 344.924 161.336C352.63 161.336 358.876 167.583 358.876 175.288Z",
    fill: "#242D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.276 156.987C349.276 150.638 356.636 147.125 361.573 151.116C366.393 155.013 364.723 162.738 358.723 164.295C353.941 165.536 349.276 161.927 349.276 156.987Z",
    fill: "#242D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.279 254.683L260.607 250.483L275.947 241.299L268.436 239.316L268.88 237.305L283.456 237.17L285.403 249.113L265.279 254.683Z",
    fill: "#242D3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_88148",
    x1: 275,
    y1: 0,
    x2: 275,
    y2: 380,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A892CA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_727_88148",
    x1: 211.453,
    y1: 190,
    x2: 359.32,
    y2: 105.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A55E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_727_88148",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(527.523 367.564) rotate(-155.7) scale(380.285 579.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012D76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#637782",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_727_88148",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4672 43.5273) rotate(30.9655) scale(737.208 998.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B91618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7963FF",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_727_88148",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.20009e-05 380) rotate(-26.113) scale(346.127 231.795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#497A96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_727_88148",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.533 326.455) rotate(-71.1652) scale(278.494 224.784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3996FE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5237F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_727_88148",
    x1: 307.759,
    y1: 193.379,
    x2: 307.759,
    y2: 257.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_727_88148",
    x1: 299.061,
    y1: 293.403,
    x2: 353.178,
    y2: 363.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_727_88148",
    x1: 343.02,
    y1: 193.381,
    x2: 343.02,
    y2: 382.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28F8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError403);
export default __webpack_public_path__ + "static/media/Error-403.101050761162938f2851f69f43086248.svg";
export { ForwardRef as ReactComponent };